export const DISABILITY_TYPE_OPTIONS = [
    { value: "", label: "None / not specified" },
    { value: "Physical", label: "Physical" },
    { value: "Visual", label: "Visual" },
    { value: "Hearing", label: "Hearing" },
    { value: "Learning", label: "Learning" },
    { value: "Behavioral", label: "Behavioral" },
    { value: "Multiple", label: "Multiple" },
    { value: "Other", label: "Other" },
];

export function disabilityTypeLabel(value) {
    const match = DISABILITY_TYPE_OPTIONS.find((item) => item.value === String(value || "").trim());
    return match?.label || String(value || "").trim() || "None / not specified";
}

export function hasSpecialNeedsRecord(student) {
    return Boolean(
        String(student?.disabilityType || "").trim() ||
            String(student?.specialNeedsNotes || "").trim() ||
            String(student?.supportRequired || "").trim()
    );
}
